<template>
  <v-container>

    <template v-if="currentUser !== ''">
      <v-layout row wrap>
        <v-flex xs12>
          <h2>Let's just Zoom</h2>
        </v-flex>

        <v-flex xs12>
          <Autocomplete
            title="Where are you now?"
            id="autocomplete-origin" 
            icon="trip_origin"
            enableGeolocation
            v-on:placechanged="setOriginV">
          </Autocomplete>
        </v-flex>

        <v-flex xs12>
          <Autocomplete 
              title="Where are you going?"
              id="autocomplete-destination" 
              v-on:placechanged="setDestinationV">
          </Autocomplete>
        </v-flex>

        <v-flex xs12>
          <Suggestions></Suggestions>
        </v-flex>

        <v-flex xs12 class="text-xs-right">
          <v-btn color="accent" @click.native="handleZoom()">Let's Zoom!</v-btn>
        </v-flex>
      </v-layout>
    </template>

    <!-- Create an Event and invite fiends -->
    <v-layout row wrap justify-space-between mt-4>
      <v-flex xs12 md5>
        <v-card flat color="transparent">
          <h2>Create and Share Events</h2>
          <p>With ZoomRyde you're able to create public, and private, events to share with your friends or keep to yourself! You'll be able to quickly get rides estimates once the event is created.</p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" to="/event">Create an Event</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md5>
        <v-card flat color="transparent">
          <h2>Add and Manage Places</h2>
          <p>Do you have a few favorite places you like to go to for lunch, but don't know which is closer or faster? Then add your favorite place!</p>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" to="/location/new">Create a Location</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Adjust your settings -->

  </v-container>
</template>

<script>
  import { eventBus } from '../main'
  //Access to the vuex store
  import { mapState } from 'vuex'

  import Autocomplete from '@/components/Autocomplete'
  import Suggestions from '@/components/Suggestions'

  export default {
    name: "home", 
    components: {
    	Autocomplete, Suggestions
    },
    data() {
      return {
        origin: {}, 
        destination: {}, 
        color: 'info',
        test_rydes: 
          [
            {
              "rideID": "lyft",
              "displayName": "Lyft",
              "priceCurrency": "USD",
              "priceFloor": 12,
              "priceCeiling": 15,
              "priceEstimate": "$12.00-15.00",
              "priceMultiplier": 1,
              "rideDuration": 18,
              "rideDistance": 5.6,
              "deepLink": "lyft://ridetype?id=lyft&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&destination[latitude]=34.0559781&destination[longitude]=-117.59805699999998"
            },
            {
              "rideID": "a2b22ddc-f218-45f5-88fa-9ae2f06bfb26",
              "displayName": "UberX",
              "priceCurrency": "USD",
              "priceFloor": 13,
              "priceCeiling": 17,
              "priceEstimate": "$13-17",
              "rideDuration": 15,
              "rideDistance": 6.26,
              "deepLink": "http://m.uber.com/ul?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&pickup[nickname]=Origin&pickup[formatted_address]=&dropoff[latitude]=34.0559781&dropoff[longitude]=-117.59805699999998&dropoff[nickname]=Destination&dropoff[formatted_address]=&product_id=a2b22ddc-f218-45f5-88fa-9ae2f06bfb26&link_text=View+ride+detailspartner_deeplink=https%3A%2F%2Fzoomryde.com%2F"
            },
            {
              "rideID": "cbd9aef8-c66d-4984-ab26-1023b68d990f",
              "displayName": "Español",
              "priceCurrency": "USD",
              "priceFloor": 13,
              "priceCeiling": 17,
              "priceEstimate": "$13-17",
              "rideDuration": 15,
              "rideDistance": 6.26,
              "deepLink": "http://m.uber.com/ul?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&pickup[nickname]=Origin&pickup[formatted_address]=&dropoff[latitude]=34.0559781&dropoff[longitude]=-117.59805699999998&dropoff[nickname]=Destination&dropoff[formatted_address]=&product_id=cbd9aef8-c66d-4984-ab26-1023b68d990f&link_text=View+ride+detailspartner_deeplink=https%3A%2F%2Fzoomryde.com%2F"
            },
            {
              "rideID": "d238c323-dc08-4d6a-8b8d-1eee8e9b0e72",
              "displayName": "Assist",
              "priceCurrency": "USD",
              "priceFloor": 13,
              "priceCeiling": 17,
              "priceEstimate": "$13-17",
              "rideDuration": 15,
              "rideDistance": 6.26,
              "deepLink": "http://m.uber.com/ul?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&pickup[nickname]=Origin&pickup[formatted_address]=&dropoff[latitude]=34.0559781&dropoff[longitude]=-117.59805699999998&dropoff[nickname]=Destination&dropoff[formatted_address]=&product_id=d238c323-dc08-4d6a-8b8d-1eee8e9b0e72&link_text=View+ride+detailspartner_deeplink=https%3A%2F%2Fzoomryde.com%2F"
            },
            {
              "rideID": "171c6d38-abb3-42b2-b8b7-a9c97b5b39b8",
              "displayName": "WAV",
              "priceCurrency": "USD",
              "priceFloor": 13,
              "priceCeiling": 17,
              "priceEstimate": "$13-17",
              "rideDuration": 15,
              "rideDistance": 6.26,
              "deepLink": "http://m.uber.com/ul?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&pickup[nickname]=Origin&pickup[formatted_address]=&dropoff[latitude]=34.0559781&dropoff[longitude]=-117.59805699999998&dropoff[nickname]=Destination&dropoff[formatted_address]=&product_id=171c6d38-abb3-42b2-b8b7-a9c97b5b39b8&link_text=View+ride+detailspartner_deeplink=https%3A%2F%2Fzoomryde.com%2F"
            },
            {
              "rideID": "db18c977-732f-4e8a-830b-53b2838d9931",
              "displayName": "UberXL",
              "priceCurrency": "USD",
              "priceFloor": 18,
              "priceCeiling": 23,
              "priceEstimate": "$18-23",
              "rideDuration": 15,
              "rideDistance": 6.26,
              "deepLink": "http://m.uber.com/ul?client_id=Dezdtol77lCZ8Tg8MeHTslkALS_BN3yB&action=setPickup&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&pickup[nickname]=Origin&pickup[formatted_address]=&dropoff[latitude]=34.0559781&dropoff[longitude]=-117.59805699999998&dropoff[nickname]=Destination&dropoff[formatted_address]=&product_id=db18c977-732f-4e8a-830b-53b2838d9931&link_text=View+ride+detailspartner_deeplink=https%3A%2F%2Fzoomryde.com%2F"
            },
            {
              "rideID": "lyft_plus",
              "displayName": "Lyft XL",
              "priceCurrency": "USD",
              "priceFloor": 18,
              "priceCeiling": 21,
              "priceEstimate": "$18.00-21.00",
              "priceMultiplier": 1,
              "rideDuration": 18,
              "rideDistance": 5.6,
              "deepLink": "lyft://ridetype?id=lyft_plus&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&destination[latitude]=34.0559781&destination[longitude]=-117.59805699999998"
            },
            {
              "rideID": "lyft_premier",
              "displayName": "Lux",
              "priceCurrency": "USD",
              "priceFloor": 28,
              "priceCeiling": 32,
              "priceEstimate": "$28.00-32.00",
              "priceMultiplier": 1,
              "rideDuration": 18,
              "rideDistance": 5.6,
              "deepLink": "lyft://ridetype?id=lyft_premier&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&destination[latitude]=34.0559781&destination[longitude]=-117.59805699999998"
            },
            {
              "rideID": "NA",
              "displayName": "Taxi",
              "priceCurrency": "USD",
              "priceEstimate": "$27.51",
              "priceFloor": 27.51,
              "priceCeiling": 27.51,
              "rideDuration": 15,
              "rideDistance": 6.28
            },
            {
              "rideID": "lyft_lux",
              "displayName": "Lux Black",
              "priceCurrency": "USD",
              "priceFloor": 40,
              "priceCeiling": 45,
              "priceEstimate": "$40.00-45.00",
              "priceMultiplier": 1,
              "rideDuration": 18,
              "rideDistance": 5.6,
              "deepLink": "lyft://ridetype?id=lyft_lux&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&destination[latitude]=34.0559781&destination[longitude]=-117.59805699999998"
            },
            {
              "rideID": "lyft_luxsuv",
              "displayName": "Lux Black XL",
              "priceCurrency": "USD",
              "priceFloor": 50,
              "priceCeiling": 55,
              "priceEstimate": "$50.00-55.00",
              "priceMultiplier": 1,
              "rideDuration": 18,
              "rideDistance": 5.6,
              "deepLink": "lyft://ridetype?id=lyft_luxsuv&pickup[latitude]=34.0247019&pickup[longitude]=-117.59427069999998&destination[latitude]=34.0559781&destination[longitude]=-117.59805699999998"
            }
          ]
      }
    }, 
    methods: {
      setOriginV: function(formattedPlace, rawPlace) {
        this.origin = formattedPlace;
      }, 
      setDestinationV: function(formattedPlace, rawPlace) {
        this.destination = formattedPlace;
      }, 
      handleZoom(){
        if(this.user == null){
          eventBus.$emit('snackAlert', {color: 'warning', text: 'You must be signed in to retreive ride estimates.'});
        } else if (this.destination.string == null || this.origin.string == null){
          eventBus.$emit('snackAlert', {color: 'warning', text: 'You are missing either your origin or destination.'});
        } else {
          this.$router.push({ name: 'Rydes', params: {origin: this.origin.string, dest: this.destination.string} });
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.users.user, 
        currentUser: state => state.users.currentUser
      }),
      disabled() {
        if(this.user == null){
          eventBus.$emit('snackAlert', {color: 'warning', text: 'You must be signed in to retreive ride estimates.'});
          return true;
        } else if (this.destination.string == null || this.origin.string == null){
          eventBus.$emit('snackAlert', {color: 'warning', text: 'You\'re missing either your origin or destination.'});
          return true;
        } else {
          return false;
        }
      }
    }
  }
</script>

<style>

</style>